import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faArrowLeft,
  faUser,
  faPhone,
  faEnvelopeOpen
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FaPhoneAlt } from 'react-icons/fa';

const ActionButtons = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [openChat, setOpenChat] = useState(false);

  /* ---------------- RESIZE ---------------- */
  useEffect(() => {
    const resize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  const showText = screenWidth > 768;

  /* ---------------- STYLES ---------------- */
  const styles = {
    barWrapper: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      zIndex: 1000,
      background: '#fff',
      boxShadow: '0 -2px 12px rgba(0,0,0,.1)',
    },

    /* 🔥 3 COLUMN GRID */
    bar: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '12px',
      padding: '12px',
      maxWidth: '1000px',
      margin: '0 auto',
    },

   btn: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',

  fontFamily:
    "'Roboto', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",

  background: '#ffffff',
  border: '1px solid #ffffff',
  borderRadius: '10px',
  fontWeight: 500,
  cursor: 'pointer',
  fontSize: '17px',
  color: '#333',
  padding: '12px 10px',
  textDecoration: 'none',
  transition: 'all 0.2s ease',
},

  };

  /* ---------------- CHAT PANEL STYLES ---------------- */
  const chat = {
    panel: {
      position: 'fixed',
      right: '20px',
      bottom: '90px',
      width: '340px',
      background: '#fff',
      borderRadius: '20px',
      boxShadow: '0 10px 40px rgba(0,0,0,.25)',
      zIndex: 2000,
    },
    header: {
      background: '#1f7a45',
      color: '#fff',
      padding: '14px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      borderRadius: '20px 20px 0 0',
      fontSize: '18px',
      fontWeight: 600,
    },
    body: {
      padding: '18px',
    },
    online: {
      color: '#1f7a45',
      fontSize: '14px',
      marginBottom: '15px',
    },
    inputWrap: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      borderBottom: '1px solid #ddd',
      marginBottom: '15px',
      paddingBottom: '6px',
    },
    input: {
      border: 'none',
      outline: 'none',
      width: '100%',
      fontSize: '14px',
    },
    submit: {
      background: '#1f7a45',
      color: '#fff',
      width: '100%',
      padding: '12px',
      border: 'none',
      borderRadius: '10px',
      fontWeight: 600,
      cursor: 'pointer',
      marginTop: '10px',
    },
  };

  return (
    <>
      {/* ACTION BAR */}
      <div style={styles.barWrapper}>
        <div style={styles.bar}>
          <button style={styles.btn}>
            <FontAwesomeIcon icon={faEnvelope} color="#ff6600" />
            {showText && 'ENQUIRE NOW'}
          </button>

          <a href="tel:0000000000" style={styles.btn}>
            <FaPhoneAlt color="#1f7a45" />
            {showText && 'CONTACT US'}
          </a>

          <button style={styles.btn} onClick={() => setOpenChat(true)}>
            <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
            {showText && 'CHAT IN WHATSAPP'}
          </button>
        </div>
      </div>

      {/* CHAT PANEL */}
      {openChat && (
        <div style={chat.panel}>
          <div style={chat.header}>
            <FontAwesomeIcon
              icon={faArrowLeft}
              style={{ cursor: 'pointer' }}
              onClick={() => setOpenChat(false)}
            />
            Hi, Welcome
          </div>

          <div style={chat.body}>
            <p>We are always here to help you.</p>
            <strong>Customer Care</strong>
            <div style={chat.online}>● Online</div>

            <div style={chat.inputWrap}>
              <FontAwesomeIcon icon={faUser} />
              <input style={chat.input} placeholder="Enter your name" />
            </div>

            <div style={chat.inputWrap}>
              <FontAwesomeIcon icon={faPhone} />
              <input style={chat.input} placeholder="Enter your mobile number" />
            </div>

            <div style={chat.inputWrap}>
              <FontAwesomeIcon icon={faEnvelopeOpen} />
              <input style={chat.input} placeholder="Enter your email" />
            </div>

            <button style={chat.submit}>SUBMIT</button>
          </div>
        </div>
      )}
    </>
  );
};

export default ActionButtons;
